var _path, _path2, _path3, _line, _line2, _line3, _line4;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgClientsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 25,
    viewBox: "0 0 22 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.03384 6.59277C3.71094 6.59277 2.63477 7.65989 2.63477 8.97174C2.63477 10.2836 3.71091 11.3507 5.03384 11.3507C6.35678 11.3507 7.43292 10.2836 7.43292 8.97174C7.43292 7.65993 6.35678 6.59277 5.03384 6.59277ZM5.03384 10.671C4.08931 10.671 3.32023 9.90836 3.32023 8.97174C3.32023 8.03512 4.08931 7.2725 5.03384 7.2725C5.97838 7.2725 6.74745 8.03512 6.74745 8.97174C6.74745 9.90836 5.97841 10.671 5.03384 10.671Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.665066
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.03411 13.2451C2.57745 13.2451 0.416017 16.2236 0.416017 18.6597C0.416017 18.8473 0.569568 18.9995 0.758752 18.9995C0.947935 18.9995 1.10149 18.8473 1.10149 18.6597C1.10149 16.5981 2.95514 13.9248 5.03411 13.9248C7.11307 13.9248 8.64139 16.5981 8.64139 18.6597C8.64139 18.8473 8.79494 18.9995 8.98412 18.9995C9.17331 18.9995 9.32686 18.8473 9.32686 18.6597C9.32686 16.2236 7.49076 13.2451 5.03411 13.2451Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.665066
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.783203 18.7129L8.91386 18.7129",
    stroke: "white",
    strokeWidth: 1.33013,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 0.8,
    y1: 1.2,
    x2: 21.2,
    y2: 1.2,
    stroke: "white",
    strokeWidth: 1.6,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 0.8,
    y1: 24.2,
    x2: 21.2,
    y2: 24.2,
    stroke: "white",
    strokeWidth: 1.6,
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 11.8,
    y1: 8.2,
    x2: 21.2,
    y2: 8.2,
    stroke: "white",
    strokeWidth: 1.6,
    strokeLinecap: "round"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 13.8,
    y1: 16.2,
    x2: 21.2,
    y2: 16.2,
    stroke: "white",
    strokeWidth: 1.6,
    strokeLinecap: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClientsIcon);
export default __webpack_public_path__ + "static/media/ClientsIcon.98251d704b5e7f3b9682d5784022d00a.svg";
export { ForwardRef as ReactComponent };